<div>
	@if (dayVisitSeries(); as dayVisitSeries) {
	<lib-card [title]="'Daily visits'">
		<lib-line-chart [multiSeries]="dayVisitSeries" [xAxisLabel]="'Date'" [yAxisLabel]="'Visits'"></lib-line-chart>
	</lib-card>
	}
</div>

@if (latestPageInitsTable(); as latestPageInitsTable) {
<lib-card [title]="'Latest page inits'" class="push-top-md">
	<lib-table [table]="latestPageInitsTable"></lib-table>
</lib-card>
}
